module.exports = __webpack_public_path__ + "media/images/athletes/2833-47344ac3ec02dec2683a9d98bfc37553.png";